export default __webpack_public_path__ + "e1e6a41244c9f1c6f7f7847563d9a6c2.png";